const monkeyData = {
  slug: "monkey",
  name: "Honda Monkey",

  hero: {
    shortDescription:
      "Motor mini ikonik Honda dengan desain klasik, mesin 125cc, dan karakter fun bike yang unik",

    variants: [
      {
        key: "banana-yellow",
        label: "Standard",
        fullName: "Honda Monkey Banana Yellow",
        startPrice: 82721000,
      },
      {
        key: "pearl-nebula-red",
        label: "Standard",
        fullName: "Honda Monkey Pearl Nebula Red",
        startPrice: 82721000,
      },
      {
        key: "pearl-shining-black",
        label: "Standard",
        fullName: "Honda Monkey Pearl Shining Black",
        startPrice: 82721000,
      },
    ],

    slides: [
      {
        variantKey: "banana-yellow",
        image: "/assets/motor/produk/monkey/honda-monkey-banana-yellow.webp",
        specs: {
          engine: "125 cc",
          transmission: "Manual 5 Percepatan",
          abs: true,
        },
      },
      {
        variantKey: "pearl-nebula-red",
        image: "/assets/motor/produk/monkey/Honda-Monkey-Pearl-Nebula-Red.webp",
        specs: {
          engine: "125 cc",
          transmission: "Manual 5 Percepatan",
          abs: true,
        },
      },
      {
        variantKey: "pearl-shining-black",
        image: "/assets/motor/produk/monkey/Honda-Monkey-Pearl-Shining-Black.webp",
        specs: {
          engine: "125 cc",
          transmission: "Manual 5 Percepatan",
          abs: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Monkey merupakan motor mini legendaris dengan desain retro yang ikonik dan karakter fun bike yang kuat.",
      },
      {
        type: "paragraph",
        text:
          "Mengusung mesin 125cc berpendingin udara dan transmisi manual, Monkey memberikan sensasi berkendara yang menyenangkan.",
      },
      {
        type: "heading",
        text: "Desain Klasik Ikonik",
      },
      {
        type: "paragraph",
        text:
          "Tangki bahan bakar berbentuk bulat, jok empuk, serta rangka kecil menjadikan Honda Monkey tampil unik dan mudah dikenali.",
      },
      {
        type: "heading",
        text: "Teknologi Modern",
      },
      {
        type: "paragraph",
        text:
          "Meskipun tampil klasik, Honda Monkey telah dibekali teknologi modern seperti ABS, panel meter digital, dan lampu LED.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4-Langkah, SOHC, Silinder Tunggal"],
      ["Kapasitas Mesin", "124,9 cc"],
      ["Sistem Pendingin", "Air Cooled"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "6,9 kW / 6.750 rpm"],
      ["Torsi Maksimum", "11 Nm / 5.500 rpm"],
      ["Tipe Transmisi", "Manual 5 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Backbone"],
      ["Suspensi Depan", "Upside Down (USD)"],
      ["Suspensi Belakang", "Twin Shock"],
      ["Rem Depan", "Cakram + ABS"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.711 x 755 x 1.030 mm"],
      ["Jarak Sumbu Roda", "1.145 mm"],
      ["Tinggi Jok", "775 mm"],
      ["Berat", "104 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "5,6 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Full Digital"],
      ["Lampu", "Full LED"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Monkey",
    items: [
      {
        title: "Desain Retro Ikonik",
        desc:
          "Tampilan klasik yang khas dengan detail modern khas Honda.",
      },
      {
        title: "Mesin 125cc PGM-FI",
        desc:
          "Performa halus dan efisien untuk pengalaman berkendara yang fun.",
      },
      {
        title: "Suspensi USD",
        desc:
          "Memberikan handling stabil dan tampilan semakin premium.",
      },
      {
        title: "Rem ABS",
        desc:
          "Sistem pengereman lebih aman saat kondisi darurat.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Informasi berkendara ditampilkan secara jelas dan modern.",
      },
      {
        title: "Lampu Full LED",
        desc:
          "Pencahayaan optimal dengan konsumsi daya efisien.",
      },
    ],
  },
};

export default monkeyData;
